var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex text-gray-900 "},_vm._l((_vm.tabs),function(tab,idx){return _c('button',{key:idx,staticClass:"\n      whitespace-nowrap\n      border border-gray-900\n      font-bold\n      text-sm\n      px-3\n      py-2\n    ",class:{
      'text-white bg-gray-900': _vm.activeTab === tab,
      'material-icons': _vm.iconMode,
      'rounded-l-md' : idx === 0,
      'rounded-r-md' : idx === _vm.tabs.length-1
    },on:{"click":function($event){_vm.activeTab = tab}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }